import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const TrailCompletionModal = ({ show, patientId, setShowModal }) => {
  const { t } = useTranslation();
  console.log("trail completion modal")
  return (
    <div>
      <Modal show={show} backdrop="static" keyboard={false} centered>
        <div className="mx-3">
          <Modal.Body className="text-center">
            <div className="patient-header-text mt-4 brandon-grotesque-bold" style={{ color: '#000' }}>
              {t('You have finished the trial modules of DLP')}!​
            </div>
            <div className="py-4 brandon-grotesque-regular" style={{ lineHeight: '21px' }}>
              {t('The remaining modules')}
            </div>
            <i className='brandon-grotesque-regular-it'>*{t('All information recorded')}.</i>
            <div>
              <i className='brandon-grotesque-regular-it'>*{t('freeOfCharge')}.</i>
            </div>
          </Modal.Body>
          <div className="pb-3 mx-3">
            <button
              className="custom-primary-button mt-2"
              style={{ lineHeight: '1.2rem' }}
              onClick={() =>
                (window.location.href = '/patient/ftr_doctor_info')
              }
            >
              <div>{t('My Healthcare Provider is a')} </div>
              <div>{t('DLP Advocate')}. </div>
              <div>{t('Sign up now')}.</div>
            </button>
            <button
              onClick={() => setShowModal(false)}
              className="custom-transparent-button mt-2"
            >
              {t('Close')}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TrailCompletionModal;
